import * as React from 'react';
import { ModalWindow, InlineText3, ArticleHeading2 } from '@cian/ui-kit';

/***** COMPONENTS *****/
import { trackPopupShow, trackPopupClose } from '../../analytics';

/***** STYLES *****/
import * as styles from './LastHopePopup.css';
import { incrementCountPopupShowed } from '../../utils/businessLogic/lastHopePopup';
import { LAST_HOPE_SHOWED_DELAY } from '../../constants/lastHopePopup';
import { ActionButtonContainer } from '../../containers/ActionButton';

/**
 * @description Интерфейс попапа последней надежды
 * @param defaultOpen {boolean} открыт ли попап по умолчанию
 * @param builderName {string | null} имя застройщика
 * */
export interface ILastHopePopupProps {
  isDefaultOpen(): boolean;
  builderName: string | null;
  newbuildingChatOpened: boolean;
}

export interface ILastHopePopupState {
  open: boolean;
}

/***** COMPONENT *****/
export class LastHopePopup extends React.PureComponent<ILastHopePopupProps, ILastHopePopupState> {
  public constructor(props: ILastHopePopupProps) {
    super(props);

    this.state = { open: false };
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public timer: any;

  public componentDidMount() {
    this.timer = setTimeout(() => {
      if (!this.props.isDefaultOpen() || this.props.newbuildingChatOpened) {
        return;
      }

      this.setState({ open: true });
      trackPopupShow();
      incrementCountPopupShowed();
    }, LAST_HOPE_SHOWED_DELAY);
  }

  public componentWillUnmount() {
    clearTimeout(this.timer);
  }

  public handleClose = () => {
    this.setState({ open: false });
    trackPopupClose();
  };

  public render() {
    const { open } = this.state;
    const { builderName } = this.props;

    return (
      <ModalWindow
        escape
        open={open}
        onClose={this.handleClose}
        content={
          <div className={styles.container}>
            <div className={styles.leftColumn} />
            <div className={styles.rightColumn}>
              <ArticleHeading2>Позвоните застройщику, чтобы узнать ещё больше</ArticleHeading2>
              <div className={styles.button}>
                <ActionButtonContainer
                  onlyBuilderPhone
                  XXL
                  analyticOnOpenActionName="Open_bannerCallnow"
                  dynamicCalltrackingPlaceType="lastHopePopup"
                />
              </div>
              {builderName ? <InlineText3 color={'black_60'}>Застройщик {builderName}</InlineText3> : null}
            </div>
          </div>
        }
      />
    );
  }
}
